import "@/css/components/avatar.scss";
import classNames from "classnames";
import React from "react";

export interface AvatarProps {
    className?: string,
    size: number,
    src?: string,
    initials?: string
}

export function Avatar({ className, size, src, initials }: AvatarProps) {
    return (
        <div className={classNames("avatar", className)} style={{width: `${size}px`, height: `${size}px`}}>
            {(src ? (
                <img src={src} alt="" />
            ) : (
                <span style={{fontSize: `${size * 0.4}px`}}>{initials}</span>
            ))}
        </div>
    )
}
